import * as React from 'react';

import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';

import StudentFilter from './StudentFilter';
import { post } from '../Services/services';

import { useRecoilState } from 'recoil';
import { ReportsFilterState } from '../Services/RecoilService';

export default function FilterDrawer(props) {
  const [reportsFilter, setReportsFilter] = useRecoilState(ReportsFilterState);
  const filterDatas = reportsFilter.filterDatas;
  const setFilterDatas = (newVal) => setReportsFilter(prev => ({
    ...prev,
    filterDatas: typeof newVal === 'function' ? newVal(prev.filterDatas) : newVal
  }));

  const [filterCount, setFilterCount] = React.useState(0)
  const [appliedFilters, setAppliedFilters] = React.useState([]); // New state for applied filter names
  const [groupsList, setGroupsList] = React.useState([]);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const closeTheDrawer = () => {

  }
  const toggleDrawer = (anchor, open) => (event) => {

    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const [filterData, setFilterData] = React.useState([]);

  // Function to get applied filter category names
  const getAppliedFilterNames = (filterData) => {
    const filterMapping = {
      selectedCourse: 'Course',
      selectedAddmisonProcess: 'Admission Process',
      selectedPaymentModes: 'Payment Modes',
      selectedFamilyIncome: 'Family Income',
      selectedBuddy: 'Buddy',
      selectedBatchMode: 'Batch Mode',
      selectedTag: 'Tag',
      selectedStudentTag: 'Student Tag',
      selectedBatches: 'Batches',
      selectedOccupation: 'Occupation',
      selectedCountry: 'Country',
      selectedPaymentStatus: 'Payment Status',
      selectedAddon: 'Addon',
      selectedCity: 'City',
      selectedState: 'State',
      selectedBoard: 'Board',
      selectedReference: 'Reference',
      selectedCareerOptions: 'Career Options',
      selectedSource: 'Source',
      selectedNextExpectedCource: 'Next Expected Course',
      selectedSchool: 'School',
      selectedCreatedBy: 'Created By',
      selectedCounsellor: 'Counsellor',
      selectedBloodGroup: 'Blood Group',
      selectedPreviousClass: 'Previous Class',
      selectedDesignation: 'Designation',
      selectedBanks: 'Banks'
    };

    const appliedCategories = [];
    let totalCount = 0;

    // Check array-based filters
    Object.keys(filterData).forEach(key => {
      if (key.startsWith('selected') && Array.isArray(filterData[key]) && filterData[key].length > 0) {
        if (filterMapping[key]) {
          appliedCategories.push(filterMapping[key]);
          totalCount += filterData[key].length;
        }
      }
    });

    // Check date filter separately
    if (filterData.dateFilter &&
      ((filterData.dateFilter.startDate && filterData.dateFilter.startDate.trim() !== '') ||
        (filterData.dateFilter.endDate && filterData.dateFilter.endDate.trim() !== ''))) {
      appliedCategories.push('Date Range');
      totalCount += 1;
    }

    return { categories: appliedCategories, count: totalCount };
  };

  React.useEffect(() => {
    const { categories, count } = getAppliedFilterNames(filterDatas);
    setAppliedFilters(categories);
    setFilterCount(count);

    // Only pass filter names if there are actually applied filters
    if (props.setAppliedFilterNames) {
      props.setAppliedFilterNames(categories.length > 0 ? categories : []);
    }
  }, [filterDatas]);

  const xfilterData = async () => {
    const res = await post('fieldTypes/getFilterData', {});
    setFilterData(res.data);
  }
  let data = filterDatas;

  const filterStudent = (d) => {
    props.getReport({ filter: d, searchText: props.searchText, page: props.paginationModel, datefilter: props.dates, groupBy: props?.statusFilter });
  }

  React.useEffect(() => {
    props.setPaginationModel({ page: 0, pageSize: 15 })
    props.getReport({ filter: data, searchText: props.searchText, page: props.paginationModel, datefilter: props.dates, groupBy: props?.statusFilter })
  }, [props.searchText, props.dates, props?.statusFilter]);

  React.useEffect(() => {
    props.getReport({ filter: data, searchText: props.searchText, page: props.paginationModel, datefilter: props.dates, groupBy: props?.statusFilter })
  }, [props.paginationModel]);

  React.useEffect(() => {
    xfilterData()
  }, [])

  // const getCity = async (data) => {
  //   const res = await post(`fieldTypes/getCitybyState`, { stateIds: data });
  //   setCity(res.data)
  // }

  const getGroups = async (data) => {
    const res = await post("fieldTypes/getfilterStateBoardSchool", { countryIds: data });
    setGroupsList(res.data);
  }

  React.useEffect(() => {
    setFilterDatas(prevState => (
      { ...prevState, selectedState: [] }));
    setFilterDatas(prevState => (
      { ...prevState, excludedState: [] }));
    setFilterDatas(prevState => (
      { ...prevState, selectedSchool: [] }));
    setFilterDatas(prevState => (
      { ...prevState, excludedSchool: [] }));
    setFilterDatas(prevState => (
      { ...prevState, selectedBoard: [] }));
    setFilterDatas(prevState => (
      { ...prevState, excludedBoard: [] }));
    if (filterDatas.selectedCountry?.length > 0) {
      getGroups(filterDatas?.selectedCountry)
    }
  }, [filterDatas.selectedCountry])

  React.useEffect(() => {
    setFilterDatas(prevState => (
      { ...prevState, selectedCity: [] }));
    setFilterDatas(prevState => (
      { ...prevState, excludedCity: [] })); // Fixed typo: excludedSity -> excludedCity

  }, [filterDatas.selectedState])

  return (
    <div>
      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button
            ref={props.filterRef}
            onClick={toggleDrawer(anchor, true)}
            variant='outlined'
            sx={{ color: '#7B7B7B', textTransform: 'none' }}
            className=' border-cyan-400 '
          >
            {filterCount === 0 ?
              <div>Filter </div>
              :
              <div>
                {filterCount + " "}
                Filters Applied
              </div>
            }
          </Button>
          <Drawer
            sx={{ zIndex: 1500 }}
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            <StudentFilter
              setPaginationModel={props.setPaginationModel}
              paginationModel={props.paginationModel}
              filterDatas={filterDatas}
              setFilterDatas={setFilterDatas}
              setState={setState}
              state={state}
              setFilterCount={setFilterCount}
              filterCount={filterCount}
              getStudent={filterStudent}
              filterData={filterData}
              statusFilter={props?.statusFilter}
              groupsList={groupsList}
            />
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}